import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  Box, Typography, Button, Grid, TableContainer, Table, TableHead,
  TableCell, TableBody, TableRow, Paper, TextareaAutosize, Modal, Select, MenuItem, Link, Card, CardContent, TextField, Snackbar, Alert, Checkbox
} from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import axios from 'axios'
import legolasApi from '../../api/legolas'
import { filter, floor, isArray, isEmpty, isNull, size } from 'lodash'
import globalConfig from '../../utils/globalConfig'
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'
import generateToken from '../../utils/generateToken'

const ReturnForm = (props) => {
  return (
    <StyledTableRow>
      <StyledTableCell align='left' sx={{ maxWidth: '250px' }}>{props.item.name} <br></br> SKU:{props.item.sku}<br></br> Oracle Id:{props.item.oracle_id}</StyledTableCell>
      <StyledTableCell sx={{ maxWidth: '200px' }}>SAR {(props.item.item_price_incl_tax - props.item.discount) >= 1 ? (props.item.item_price_incl_tax - props.item.discount) : '0'}</StyledTableCell>
      {props.item.is_gift_product === 0 ?
        (
          <>
            <StyledTableCell>
              <Select
                label='Select Return Reason'
                defaultValue={1}
                sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
                onChange={(e) => props.updateReturnPayload(props.item.item_id, "reason_id", e.target.value.toString())}
              >
                {props.data.return_item_reason.map(item => {
                  return (
                    <MenuItem value={item.id}>{item.title}</MenuItem>
                  )
                })}
              </Select>
            </StyledTableCell>

            <StyledTableCell>
              <Select
                label='Select Return Condition'
                defaultValue={1}
                sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
                onChange={(e) => props.updateReturnPayload(props.item.item_id, "condition_id", e.target.value.toString())}
              >
                {props.data.return_item_condition.map(item => {
                  return (
                    <MenuItem value={item.id}>{item.title}</MenuItem>
                  )
                })}
              </Select>
            </StyledTableCell>
            <StyledTableCell>
              <Select
                label='Select Return Resolution'
                defaultValue={2}
                sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
                onChange={(e) => props.updateReturnPayload(props.item.item_id, "resolution_id", e.target.value.toString())}
              >
                {props.data.return_item_resolution.map(item => {
                  return (
                    <MenuItem value={item.id}>{item.title}</MenuItem>
                  )
                })}
              </Select>
            </StyledTableCell>
            <StyledTableCell>
              <TextField
                //label="Qty" 
                variant="outlined"
                value={props.item.item_qty}
                disabled={true}
              />
            </StyledTableCell>
            <StyledTableCell>
              <Select
                label='Select Return Qty'
                defaultValue={0}
                sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
                onChange={(e) => props.updateReturnPrice(
                  props.item.item_id,
                  (props.item.item_price_incl_tax - props.item.discount),
                  e.target.value.toString(),
                  props.item.sku,
                  props.item.item_qty,
                  props.item.product_type,
                  props.item
                )}
              >
                {props.item.avl_return_qty.map(qtyNo => {
                  return (
                    <MenuItem value={qtyNo}>{qtyNo}</MenuItem>
                  )
                })}
              </Select>
            </StyledTableCell>
          </>
        )
        : (
          <>
            <StyledTableCell colSpan={4} align="center">
              This is a gift item
            </StyledTableCell>
            <StyledTableCell colSpan={3} align="center">
              <Checkbox checked={props.isGiftChecked && props.isGiftChecked[props.item.item_id] ? props.isGiftChecked[props.item.item_id].isGiftProduct : false} disabled={true} sx={{ transform: 'scale(1.5)' }} />
              &nbsp;&nbsp;
              {
                props.isGiftChecked && props.isGiftChecked[props.item.item_id] && props.isGiftChecked[props.item.item_id].isGiftProduct &&
                <span>
                  {props.isGiftChecked[props.item.item_id].giftItemQty + " Quantity"}
                </span>
              }
            </StyledTableCell>
          </>
        )
      }
    </StyledTableRow>
  )
}

const AddressInfo = (props) => {
  const { shipment } = props
  return (
    <>
      <Box>
        {shipment.customer_firstname && shipment.customer_lastname ?
          <Typography>
            {shipment.customer_firstname + ' ' + shipment.customer_lastname}
          </Typography> :
          null
        }
      </Box>
      <Box>
        {shipment.street ?
          <Typography>{shipment.street}</Typography> : null
        }
      </Box>
      <Box>
        {shipment.city && shipment.district ?
          <Typography>
            {shipment.city + ', ' + shipment.district}
          </Typography> :
          null}
      </Box>
      <Box>
        {shipment.country ? <Typography>{shipment.country}</Typography> : null}
      </Box>
      <Box>
        {shipment.phone_ext && shipment.phone ?
          <Typography>
            T : {shipment.phone_ext + shipment.phone}
          </Typography> :
          null}
      </Box>
    </>
  )
}

function CreateReturn() {
  //const { state: { data, type } } = useLocation()
  const location = useLocation();
  const data = location?.state?.data || null;
  const type = location?.state?.type || null;
  const { items, shipment, summary, transaction, customer } = data;
  const navigate = useNavigate();
  const [returnableData, setReturnableData] = React.useState([]);
  const [returningItems, setReturningItems] = React.useState([]);
  const [totalPrice, setTotalPrice] = React.useState(0);
  const [itemsPayload, setItemsPayload] = React.useState([]);
  const [adminUsers, setAdminUsers] = React.useState([]);
  const [managerId, setManagerId] = React.useState(null);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertText, setAlertText] = React.useState('');
  const [defaultCarrier, setDefaultCarrier] = React.useState(null);
  const [returnType, setReturnType] = React.useState('customer');
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [isGiftChecked, setIsGiftChecked] = React.useState({});
  const [disableSubmitBtn, setDisableSubmitBtn] = React.useState(false);
  const [orderInvoicePrice, setOrderInvoicePrice] = React.useState(0);

  React.useEffect(() => {
    // console.log('total price', totalPrice)
  }, [totalPrice])


  React.useEffect(() => {
    // console.log('Recd data: ', data)
    const promise1 = axios.post(`${legolasApi.url}/admin/returnable/items`, { "order_id": summary.order_id }, {
      headers: {
        locale: "en-sa"
      }
    })
    const promise2 = axios.get(`${legolasApi.url}/admin/rma/manager/list`)
    Promise.allSettled([promise1, promise2]).then(async (results) => {
      const res1 = results[0]
      const res2 = results[1]
      // console.log("res1: ",res1);
      const itemsData = res1.value.data.returnable_items_data;
      const returningItemss = [];
      let orderInvoiceAmount = 0;
      await itemsData.map(item => {
        returningItemss.push(item);
        if (item.is_gift_product == 0) {
          orderInvoiceAmount = orderInvoiceAmount + ((parseFloat(item.item_price_incl_tax) - parseFloat(item.discount)) * item.item_qty);
        }
      })
      setReturningItems(returningItemss)
      setReturnableData(res1.value.data)
      setDefaultCarrier(res1.value.data.shipping_method)
      setOrderInvoicePrice(orderInvoiceAmount);
      if (res2) {
        const usersData = res2.value.data.data.rows
        setAdminUsers(usersData)
        let configPayload = {
          "scope": "default",
          "scope_id": "0",
          "path": "rma/createNew/default_rma_manager"
        };
        axios.post(`${legolasApi.url}/admin/config/get/single`, configPayload).then((res) => {
          let defaultManagerId = res.data.data.value;
          const foundManager = usersData.find(user => user.user_id == defaultManagerId)
          setManagerId(foundManager.user_id)
        }).catch((error) => console.log('Error in getting config  data: ', error))

      }
      const returnableItems = res1.value.data.returnable_items_data
      if (isArray(returnableItems) && returnableItems.length > 0) {
        let itemsGroup = {}
        let totalPrice = 0.0
        returnableItems.forEach(item => {
          if (item.product_type === "bundle") {
            const filterBundleItems = filter(item.bundleOrderedItems, (bundleItem) => {
              return bundleItem.reference_id == item.sku;
            });
            if (size(filterBundleItems) > 0) {
              filterBundleItems.forEach(element => {
                let bundleReturnGrp = {};
                bundleReturnGrp.reason_id = "1";
                bundleReturnGrp.condition_id = "1";
                bundleReturnGrp.resolution_id = "2";
                bundleReturnGrp.qty_requested = "0";
                bundleReturnGrp.order_item_id = element.item_id.toString();
                bundleReturnGrp.is_gift_product = element.is_gift_product;
                bundleReturnGrp.gift_product_id = element.gift_parent_id;
                bundleReturnGrp.gift_product_sku = element.gift_product_sku;
                itemsGroup[element.item_id] = bundleReturnGrp;
              });
            }
          } else {
            let returnGroup = {};
            returnGroup.reason_id = "1";
            returnGroup.condition_id = "1";
            returnGroup.resolution_id = "2";
            returnGroup.qty_requested = "0";
            returnGroup.order_item_id = item.item_id.toString();
            returnGroup.is_gift_product = item.is_gift_product;
            returnGroup.gift_product_id = item.gift_parent_id;
            returnGroup.gift_product_sku = item.gift_product_sku;
            itemsGroup[item.item_id] = returnGroup;
          }
        })

        setTotalPrice(totalPrice.toFixed(2))
        setItemsPayload(itemsGroup)
      }
    })
  }, [])

  function updateReturnPayload(id, type, val) {
    let currentPayload = { ...itemsPayload }
    currentPayload[id][type] = val
    console.log("currentPayload", currentPayload);
    setItemsPayload(currentPayload)
  }

  function getGiftFilterDataToValidate(parentSku) {
    let filterDataToValidate = [];
    const filterChildProduct = filter(returningItems, (item) => {
      return item.is_gift_product === 1;
    });
    if (size(filterChildProduct) > 0) {
      if (filterChildProduct[0].gift_parent_id === 'cart') {
        filterDataToValidate.push(filterChildProduct[0]);
      } else {
        filterDataToValidate = filter(filterChildProduct, (product) => {
          return product.gift_parent_id === parentSku;
        });
      }
    }
    return filterDataToValidate;
  }
  function getGiftReturnQtyAfterCalculation(parentItemQty, filterDataToValidate, amountToBeReturned, returnQty) {
    const isSigleGift = filterDataToValidate.SingleGift;
    const giftXQty = filterDataToValidate.giftXQuantity;
    const giftYqty = filterDataToValidate.giftYQuantity;
    const parentId = filterDataToValidate.gift_parent_id;
    const cartTotal = filterDataToValidate.cartSubtotal;
    const giftItemQty = filterDataToValidate.item_qty;
    let giftReturnQty = 0;
    if (parentId === 'cart') {
      const remainingAmt = parseFloat(orderInvoicePrice) - parseFloat(amountToBeReturned);
      if (remainingAmt <= parseFloat(cartTotal)) {
        giftReturnQty = giftItemQty;
      }
    } else if (isSigleGift == 1) {
      const parentRemainingQty = parseInt(parentItemQty) - parseInt(returnQty);  // 3
      console.log("isSigleGift", isSigleGift, " | parentRemainingQty", parentRemainingQty);
      if (parentRemainingQty < giftXQty) {
        giftReturnQty = giftYqty;
      }
    } else {
      const giftQtyMaxReturned = floor(parseInt(parentItemQty) / parseInt(giftXQty)); // 3
      console.log("giftQtyMaxReturned", giftQtyMaxReturned);
      const parentRemainingQty = parseInt(parentItemQty) - parseInt(returnQty);  // 3
      console.log("parentRemainingQty", giftQtyMaxReturned);
      const step1 = parentRemainingQty !== 0 ? floor(parentRemainingQty / parseInt(giftXQty)) : 0; // 1
      const step2 = giftQtyMaxReturned - step1; // 2
      if (parentRemainingQty === 0) {
        giftReturnQty = giftQtyMaxReturned * parseFloat(giftYqty);
      } else {
        if (step1 === giftQtyMaxReturned) {
          // no retrun
        } else if (step1 === 0) {
          giftReturnQty = giftQtyMaxReturned * parseFloat(giftYqty)
        } else if (step2 != 0 && step2 < giftQtyMaxReturned) {
          giftReturnQty = isSigleGift == 1 ? giftYqty : (step2 * parseInt(giftYqty));
        }
      }
    }
    return giftReturnQty;
  }
  function updateItemPayloadParentAndGift(returnQty, parentSku, parentItemQty, amountToBeReturned) {
    let filterDataToValidate = getGiftFilterDataToValidate(parentSku);
    if (size(filterDataToValidate) > 0) {
      const giftReturnQty = getGiftReturnQtyAfterCalculation(parentItemQty, filterDataToValidate[0], amountToBeReturned, returnQty);
      updateReturnPayload(filterDataToValidate[0].item_id, "qty_requested", giftReturnQty);
      let giftObject = { ...isGiftChecked };
      giftObject[filterDataToValidate[0].item_id] = {
        isGiftProduct: giftReturnQty > 0 ? true : false,
        giftItemQty: giftReturnQty
      };
      setIsGiftChecked(giftObject);
    }
  }

  function updateReturnPrice(itemId, itemPrice, returnQty, parentSku, parentItemQty, productType, itemData) {
    if (productType === "bundle") {
      const filterBundleItems = filter(itemData.bundleOrderedItems, (bundleItem) => {
        return bundleItem.reference_id == parentSku;
      });
      if (size(filterBundleItems) > 0) {
        filterBundleItems.forEach(element => {
          const qtyToBeReturned = parseInt(returnQty) * element.bundleSingleItemQty;
          updateReturnPayload(element.item_id, "qty_requested", qtyToBeReturned);
        });
      }
    } else {
      updateReturnPayload(itemId, "qty_requested", returnQty);
    }
    let itemFound = false;
    console.log("selectedItems check", selectedItems)
    const newSelectedItems = selectedItems.map(item => {
      console.log("check values in items seelcted", item)
      if (item.itemId == itemId) {
        itemFound = true;
        return { ...item, returnQty: returnQty };
      }
      return item;
    });
    if (!itemFound) {
      newSelectedItems.push({
        itemId: itemId, itemPrice: itemPrice, returnQty: returnQty
      });
    }
    console.log("newSelectedItems: ", newSelectedItems);
    setSelectedItems(newSelectedItems);

    let totalProductsPrice = 0.0;
    newSelectedItems.map(item => {
      let qtyPrice = parseFloat(item.itemPrice) * parseInt(item.returnQty);
      totalProductsPrice = parseFloat(totalProductsPrice + qtyPrice);
    });
    updateItemPayloadParentAndGift(returnQty, parentSku, parentItemQty, totalProductsPrice);
    setTotalPrice(totalProductsPrice);
  }

  function handleSubmitReturn() {
    let itemsArr = []
    let submitPayload = {
      "order_id": summary.order_id.toString(),
      "comment": "",
      "comment_file": "",
      "shipping_label": defaultCarrier,
      "manager_id": managerId ? managerId : 104,
      "return_type": returnType,
      "agree_return_policy": true
    }
    Object.values(itemsPayload).forEach(value => {
      if (value.qty_requested > 0) {
        let obj = {
          "reason_id": value.reason_id,
          "condition_id": value.condition_id,
          "resolution_id": value.resolution_id,
          "qty_requested": value.qty_requested,
          "order_item_id": value.order_item_id
        }
        itemsArr.push(obj)
      }
    })

    setDisableSubmitBtn(true);
    if (itemsArr.length > 0) {
      submitPayload["items"] = itemsArr
      console.log('final submit payload', submitPayload)
      const signedToken = generateToken(submitPayload)
      const payload = { "action": "create-return" }
      axios.post(`${legolasApi.url}/api/return/create`, payload, {
        headers: {
          'Authorization': `Bearer ${signedToken}`,
          'Content-Type': 'application/json'
        }
      }).then(res => {
        console.log('Submit return result', res)
        const data = res.data
        if (data.success) {
          handleAlertGen(data.message)
        }
        setDisableSubmitBtn(false);
        handleOrderRedirection();
      })
    } else {
      console.log('No items selected to return!');
      handleAlertGen('Select atleast one item to return!');
      setDisableSubmitBtn(false);
    }
  }

  const darkBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#dcdbdb',
    padding: '10px'
  }
  const lightBox = {
    width: '100%',
    display: 'inline-flex',
    justifyContent: 'space-between',
    backgroundColor: '#fff',
    padding: '10px'
  }
  const subHeader = {
    fontSize: '1.2rem',
    fontWeight: 700,
    paddingBottom: '20px'
  }
  const handleOrderRedirection = () => {
    const link = `/orders/${summary.order_id}`
    navigate(link)
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }

  const closeAlert = () => {
    setOpenAlert(false)
  }

  const purchasedFromDefault = 'Shababuna Website'

  if (isEmpty(returningItems)) return (
    <Box sx={{ alignItems: 'center', margin: '20px 0 0 20px' }}>
      <Typography variant='h4'>No Items to Return</Typography>
    </Box>
  )

  return (
    <Box sx={{ height: 'auto', margin: '10px 20px', width: '100%', maxWidth: '90vw' }}>
      <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <Alert onClose={closeAlert} severity="success" sx={{ width: '400px', marginTop: '100px' }}>
          {alertText}
        </Alert>
      </Snackbar>
      <Box sx={{ display: 'flex' }}>
        <Typography variant='h4'>New Return</Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey, margin: '15px 0px' }}>
        <Button onClick={() => navigate(-1)} sx={{ ...globalStyles.reusableButtonLight, marginRight: '20px', padding: '0px 30px !important' }}>Back</Button>
        <Button sx={globalStyles.reusableButton} disabled={disableSubmitBtn} onClick={() => handleSubmitReturn()}> {disableSubmitBtn ? "Submitting ...." : "Submit Return"}</Button>
      </Box>
      <Box id='return-info-container'>
        <Grid container spacing={5} columns={24}>
          <Grid item xs={12}>
            <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Information</Typography>
            </Box>
            <Box id='details-container'>
              <Box sx={darkBox}>
                <Typography>RMA Status</Typography>
                <Typography>RMA Status</Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Order</Typography>
                <Typography>
                  <Box sx={{ display: 'flex' }}>
                    <Link onClick={() => handleOrderRedirection()} sx={{ cursor: 'pointer' }}>{summary.order_id ? summary.order_id : null}</Link>
                    <Typography sx={{ paddingLeft: '10px' }}>{summary.placedOn ? summary.placedOn : null}</Typography>
                  </Box>
                </Typography>
              </Box>
              <Box sx={darkBox}>
                <Typography>Order Status</Typography>
                <Typography>{summary.order_status ? summary.order_status : null}</Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Customer Name</Typography>
                <Typography>{shipment.customer_firstname ? shipment.customer_firstname : customer.firstname}</Typography>
              </Box>
              <Box sx={darkBox}>
                <Typography>Customer Group</Typography>
                <Typography>General</Typography>
              </Box>
              <Box sx={lightBox}>
                <Typography>Email</Typography>
                <Typography>{customer.email ? customer.email : summary.guest_user_email}</Typography>
              </Box>
              <Box sx={darkBox}>
                <Typography>RMA Manager</Typography>
                <Select
                  value={managerId}
                  label='Select RMA Manager'
                  placeholder='Select RMA Manager'
                  onChange={e => setManagerId(e.target.value)}
                  sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000' }}
                >
                  {
                    adminUsers.map(user => {
                      return (
                        <MenuItem value={user.user_id}>{user.firstname + ' ' + user.lastname}</MenuItem>
                      )
                    })
                  }
                </Select>
              </Box>
              <Box sx={lightBox}>
                <Typography>Return Type</Typography>
                <Select
                  label='Select Shipping Partner'
                  defaultValue={'customer'}
                  onChange={e => setReturnType(e.target.value)}
                  sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important' }}
                >
                  {/* <MenuItem value='rto'>RTO Request</MenuItem> */}
                  <MenuItem value='customer'>Customer Request</MenuItem>
                </Select>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Customer Address</Typography>
            </Box>
            <Box id='customer-address-container'>
              <AddressInfo shipment={shipment} />
            </Box>
            <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '30px 0px', paddingBottom: '10px' }}>
              <Typography variant='h6'>Tracking Information</Typography>
            </Box>
            <Box id='tracking-container'>
              <Card sx={{ width: '100%' }}>
                <CardContent>
                  <Grid container columns={12}>
                    <Grid item xs={5}>
                      <Typography variant='h6'>Carrier</Typography>
                      <Select
                        label='Select Shipping Partner'
                        defaultValue={defaultCarrier}
                        onChange={(e) => setDefaultCarrier(e.target.value)}
                        sx={{ width: '80%', borderRadius: '0px', border: '1px solid #000', backgroundColor: '#fff !important', padding: '0px', marginTop: '20px' }}
                      >
                        <MenuItem value='aramex'>Aramex Delivery</MenuItem>
                        <MenuItem value='esnad'>ESNAD Delivery</MenuItem>
                        <MenuItem value='Shababuna'>Shababuna Delivery</MenuItem>
                        <MenuItem value='helix'>Helix Delivery</MenuItem>
                        <MenuItem value='saudipost'>Saudipost Delivery</MenuItem>
                        <MenuItem value='smsa'>SMSA Delivery</MenuItem>
                      </Select>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box id='items-container'>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', marginBottom: '20px', paddingBottom: '10px' }}>
          <Typography variant='h6'>
            Items to Return
          </Typography>
        </Box>
        <Box id='return-form-container'>
          {isArray(returningItems) && returningItems.length &&
            <TableContainer component={Paper}>
              <Table aria-label="simple table"
                sx={{
                  width: 'max-content'
                }}
              >
                <TableHead sx={{
                  backgroundColor: globalStyles.colors.backgroundPrimary,
                  height: '40px !important',
                  borderRadius: '0 !important',
                  '& .MuiTableCell-root': {
                    color: '#fff !important',
                    padding: '10px !important',
                    borderRight: '2px solid #fff !important',
                    borderRadius: '0 !important'
                  }
                }}
                >
                  {globalConfig.itemReturnTableHeader.map(item => {
                    return (
                      <StyledTableCell>{item.label}</StyledTableCell>
                    )
                  })}
                </TableHead>
                <TableBody>
                  {returningItems.map(item => {
                    return (
                      <ReturnForm
                        data={returnableData} item={item} itemsPayload={itemsPayload} updateReturnPayload={updateReturnPayload}
                        updateReturnPrice={updateReturnPrice} isGiftChecked={isGiftChecked} orderInvoicePrice={orderInvoicePrice}
                      />
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          }
        </Box>
      </Box>
      <Box id='price-container' sx={{ marginBottom: '10%' }}>
        <Box sx={{ width: '100%', borderBottom: '1px solid #000', margin: '20px 0px', paddingBottom: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
          <Typography variant='h6'>
            Total Price to Return:
          </Typography>
        </Box>
        <Typography variant='h6' sx={{ fontSize: '20px', fontWeight: 'bold' }}>
          SAR {totalPrice}
        </Typography>
      </Box>
    </Box>
  )
}

export default CreateReturn